module.exports = require("lodash/isArray");